import { Component, Input, OnInit } from '@angular/core';
import { ContainerColor, IconColor } from '../avatar/avatar.component';

@Component({
  selector: 'app-icon-item-bar',
  templateUrl: './icon-item-bar.component.html',
  styleUrls: ['./icon-item-bar.component.scss'],
  host: { '[class.selected]': 'selected' }
})
export class IconItemBarComponent implements OnInit {
  @Input() icon?: string;
  @Input() iconColor: IconColor = 'white';
  @Input() iconBgColor: ContainerColor = 'primary';

  @Input() title: string = '';
  @Input() selected: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
